// main.js

import { flipSlider } from "./components/flip-slider.js";
import { textBgVideo } from "./components/text-bg-video.js";
import { cardSlider } from "./components/card-slider.js";
import { testimonialSlider } from "./components/testimonial-slider.js";
import { loader } from "./components/loader.js";
import { headerMenu } from "./components/header.js";
import { bannerFadeIn } from "./components/banner.js";
import { initBannerHeroVideoCutout } from "./components/banner-hero-cutout.js";
import { heroSharedVideo } from "./components/hero-shared-video.js";
import { bannerInner } from "./components/banner-inner.js";
import { fullcolVideo } from "./components/fullcol-video.js";
import { eventPortfolio } from "./components/event-portfolio-slider.js";
import { eventCardMedia } from "./components/event-card.js";
import { eventCardStack } from "./components/event-card-stack.js";
import { eventTimeline } from "./components/event-timeline.js";
import { initLenisSmoothScroll } from "./components/lenis-smooth-scroll.js";

/** Run as soon as this module loads (before DOMContentLoaded). Avoids late scrollRestoration. */
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

let lenisInstance = null;

function scrollDocumentAndLenisToTop() {
  window.scrollTo(0, 0);
  if (lenisInstance && typeof lenisInstance.scrollTo === "function") {
    lenisInstance.scrollTo(0, { immediate: true });
  }
}

/** Browsers (and Lenis) sometimes re-apply scroll after paint; flush over a few frames. */
function flushScrollToTop() {
  scrollDocumentAndLenisToTop();
  requestAnimationFrame(() => {
    scrollDocumentAndLenisToTop();
    requestAnimationFrame(scrollDocumentAndLenisToTop);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  lenisInstance = initLenisSmoothScroll();
  const loaderEl = document.querySelector(".loader");
  if (loaderEl) {
    const gsap = window.gsap;
    if (gsap) {
      const header = document.querySelector(".header");
      const bannerInner = document.querySelector(".banner__inner");
      if (header) gsap.set(header, { opacity: 0 });
      if (bannerInner) gsap.set(bannerInner, { opacity: 0 });
    }
  } else {
    bannerFadeIn();
  }
  flipSlider();
  heroSharedVideo();
  initBannerHeroVideoCutout();
  textBgVideo();
  cardSlider();
  testimonialSlider();
  bannerInner();
  fullcolVideo();
  eventPortfolio();
  eventCardMedia();
  eventCardStack();
  eventTimeline();
  headerMenu();



});

// Start loader when DOM and resources are fully loaded, then it holds and fades away
window.addEventListener("load", () => {
  const loaderEl = document.querySelector(".loader");
  if (loaderEl) {
    document.addEventListener("loaderContentReveal", () => bannerFadeIn(), { once: true });
  }
  loader();
});

